class OurBrands extends HTMLElement {
  constructor() {
    super();

    this.exclusiveButton = this.querySelector('.js-brands-exclusive')
    this.standardButton = this.querySelector('.js-brands-standard')

    this.exclusiveList = this.querySelector('.js-brands-exclusive-list');
    this.standardList = this.querySelector('.js-brands-standard-list')

    this.text = {
      active: ['text-black', 'relative', 'after:absolute', 'after:left-0', 'after:bottom-[1px]', 'after:block', 'after:h-[2.5px]', 'after:w-full', 'after:bg-primary-accent'],
      default: 'text-grey-600'
    }

    this.toggleVisibility = {
      visible: 'grid',
      hidden: 'hidden'
    }

    this.exclusiveButton.addEventListener('click', this.onClickExclusive.bind(this));
    if(this.standardButton) {
      this.standardButton.addEventListener('click', this.onClickStandard.bind(this));
    }
  }

  onClickExclusive(event) {
    event.preventDefault();

    this.exclusiveButton.classList.add(...this.text.active)
    this.exclusiveButton.classList.remove(this.text.default)
    this.exclusiveList.classList.add(this.toggleVisibility.visible)
    this.exclusiveList.classList.remove(this.toggleVisibility.hidden)

    if(this.standardButton) {
      this.standardButton.classList.remove(...this.text.active)
      this.standardButton.classList.add(this.text.default)
      this.standardList.classList.add(this.toggleVisibility.hidden)
      this.standardList.classList.remove(this.toggleVisibility.visible)
    }
  }

  onClickStandard(event) {
    event.preventDefault();

    this.standardButton.classList.add(...this.text.active)
    this.standardButton.classList.remove(this.text.default)
    this.exclusiveButton.classList.remove(...this.text.active)
    this.exclusiveButton.classList.add(this.text.default)

    this.standardList.classList.add(this.toggleVisibility.visible)
    this.standardList.classList.remove(this.toggleVisibility.hidden)
    this.exclusiveList.classList.add(this.toggleVisibility.hidden)
    this.exclusiveList.classList.remove(this.toggleVisibility.visible)
  }
}

customElements.define('our-brands', OurBrands);
